import React, { FC, useState } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { FlashList } from '@shopify/flash-list';
import SendingToMachineModalWrapper, { SendingToMachineModalWrapperProps } from './SendingToMachineModalWrapper';
import { connect } from 'react-redux';
import { Machine } from '@interfaces/machines';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';
import InputLine from '@components/machines/components/detailsComponents/activeMachine/components/InputLine';
import { NCFileSearchItem, NCFileVersionNumber } from '@interfaces/search';
import { sendNcFileToMachine } from '@reducers/machines';
import { ColorFunction } from '@styles/colors/types';
import { scale as initialScale } from '@components/frame';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { font as initialFont } from '@styles/fonts';
import SendNCFileModal from '@components/ncFileVersionDetails/components/sendNCFile/sendNCFileModal';

interface SendingToMachineSelectMachineStepProps extends Pick<SendingToMachineModalWrapperProps, 'C' | 'hide'> {
  machines: Machine[];
  selectedNCFile: NCFileVersionNumber;
  favoriteNCFIle: NCFileVersionNumber;
  ncFileData: NCFileSearchItem;
  ncFileContentSize: number;
}

interface MachineListProps {
  machines: Machine[];
  onSelect: (machine: Machine) => void;
  C: ColorFunction;
  containerStyles?: StyleProp<ViewStyle>;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

export const MachineList: FC<MachineListProps> = ({ machines, onSelect, C, containerStyles, scale = initialScale, font = initialFont }) => {
  return (
    <FlashList
      keyExtractor={(item) => item.machineId.toString()}
      data={machines}
      style={containerStyles}
      renderItem={({ item: machine, index }) => (
        <InputLine
          {...{
            borderBottomRadius: index === machines.length - 1,
            borderTopRadius: index === 0,
            data: machines,
            onlyLabel: true,
            index,
            i: {
              action: () => onSelect(machine),
              name: machine.shortName,
              isText: true,
            },
            C,
            loading: false,
            bg: modalFieldBg,
            scale,
            font,
            testID: TEST_IDS.sendToMachinePopup.machineItem(machine.machineId),
          }}
        />
      )}
    />
  );
};

const SendingToMachineSelectMachineStep: FC<SendingToMachineSelectMachineStepProps> = ({
  C,
  hide,
  machines,
  selectedNCFile,
  favoriteNCFIle,
  ncFileData,
  ncFileContentSize,
  sendNcFileToMachine,
}) => {
  const [selectedMachine, setSelectedMachine] = useState<Machine | null>(null);

  if (selectedMachine) {
    return (
      <SendNCFileModal
        {...{
          C,
          close: hide,
          machines,
          NCFile: ncFileData,
          favorite: favoriteNCFIle,
          selected: selectedNCFile,
          sequenceNumber: selectedNCFile?.sequenceNumber,
          firstRunOn: selectedNCFile?.firstRanOn,
          firstRunOnMachineName: selectedNCFile?.firstRanByMachineName,
          sendNcFileToMachine,
          contentSize: ncFileContentSize,
          selectedMachine: selectedMachine,
        }}
      />
    );
  }

  return (
    <SendingToMachineModalWrapper {...{ C, hide, title: 'Select Machine' }}>
      <View style={{ flex: 1 }}>
        <MachineList machines={machines} C={C} onSelect={setSelectedMachine} />
      </View>
    </SendingToMachineModalWrapper>
  );
};

export default connect(({ machines: { machines }, details: { ncFileContentSize } }) => ({ machines, ncFileContentSize }), { sendNcFileToMachine })(
  SendingToMachineSelectMachineStep
);
